var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8019_204616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43109 13.0344C8.74888 12.8426 9.14677 12.8426 9.46456 13.0344L11.2841 14.1326C12.0414 14.5897 12.9756 13.9107 12.7747 13.0493L12.2918 10.9794C12.2075 10.6179 12.3303 10.2394 12.6109 9.99638L14.22 8.60242C14.8886 8.02321 14.5312 6.92495 13.6497 6.85017L11.5335 6.67063C11.164 6.63928 10.8421 6.40594 10.6974 6.06444L9.86854 4.10889C9.52396 3.29586 8.37169 3.29587 8.02711 4.10889L7.19829 6.06444C7.05355 6.40594 6.73168 6.63928 6.3621 6.67063L4.24591 6.85017C3.36448 6.92495 3.00707 8.02321 3.67567 8.60242L5.28477 9.99638C5.56533 10.2394 5.68818 10.6179 5.60385 10.9794L5.12097 13.0493C4.92001 13.9107 5.85424 14.5897 6.61155 14.1326L8.43109 13.0344Z",
    fill: "#B08C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8019_204616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9525,
    height: 16.9525,
    fill: "white",
    transform: "translate(0.47168 0.523438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled-star.f92ea7c275223f508c6db75a3422bdef.svg";
export { ForwardRef as ReactComponent };